import { createCertificate, getPreloads, uploadCertificateFile } from '../../Api/ApiCertificate';
import { formatDate, getCache, setSnackbar } from '@/helpers';
import SwedishOrgNr from '@validators/swedish-org';
import { groupRowsToApi, isGroup } from '@enums/CompetenceType';
import moment from 'moment';

const getDefaultState = () => {
    return {
        nextStep: false,
        nextStepReady: false,
        single: false,
        preview: false,
        editId: null,
        editIndex: null,
        hasFormError: false,
        createPayload: {
            competence: {},
            issuer: {},
            client: {},
            first_name: '',
            last_name: '',
            national_identity_number: '',
            foreign_national_identity_number: false,
            email: '',
            phone_number: '',
            issued_at: null,
            certificates: [],
            file: '',
            order_id06: false,
            order_ssg: false,
            meta: {},
            expires_at: null,
            custom_expire_date: null,
            issuing_authority: null,
            authority_reference: '',
            verified: false,
            certified_department_id: null,
            group_competences: [],
        },
        preloads: {
            competences: [],
            issuer_users: [],
            clients: [],
        },
    };
};
// initial state
const state = getDefaultState();

const mutations = {
    UPDATE_SINGLE: (state) => (state.single = !state.single),
    UPDATE_CERT_FILE: (state, file) => (state.createPayload.file = file),
    SET_HAS_ERROR: (state, bool) => (state.hasFormError = bool),
    RESET_STATES: (state) => Object.assign(state, getDefaultState()),
    SET_NEXT_STEP: (state, bool) => (state.nextStep = bool),
    SET_COMPETENCE_KEY: (state, field) => {
        const key = Object.keys(field)[0];

        if (key === 'competence') {
            state.createPayload.competence.id = field[key] ? field[key].id : null;
            state.createPayload.competence.name = field[key] ? field[key].name : null;
            state.createPayload.competence.has_id06 = field[key] ? field[key].has_id06 : null;
            state.createPayload.competence.has_ssg = field[key] ? field[key].has_ssg : null;
            state.createPayload.competence.sub_competences = field[key] ? field[key].sub_competences : null;
            state.createPayload.competence.inherited_sub_competences = field[key]
                ? field[key].inherited_sub_competences
                : null;
            state.createPayload.competence.valid_months = field[key] ? field[key].valid_months : null;
            state.createPayload.competence.annual_year_date = field[key] ? field[key].annual_year_date : null;
            state.createPayload.competence.start_date = field[key] ? field[key].start_date : null;
            state.createPayload.competence.end_date = field[key] ? field[key].end_date : null;
            state.createPayload.competence.total_hours = field[key] ? field[key].total_hours : null;
            state.createPayload.competence.total_hours_distance = field[key] ? field[key].total_hours_distance : null;
            state.createPayload.competence.note = field[key] ? field[key].note : null;
            state.createPayload.competence.competence_type = field[key] ? field[key].competence_type : null;
            state.createPayload.competence.issuing_authority = field[key] ? field[key].issuing_authority : null;
            state.createPayload.issuing_authority = field[key] ? field[key].issuing_authority : null;
            state.createPayload.competence.members = field[key] ? field[key].members : null;
            state.createPayload.group_competences = [];
        }

        state.nextStepReady = !!(state.createPayload.competence.id && state.createPayload.issuer.id);
    },
    SET_PAYLOAD_CREATE(state, field) {
        const key = Object.keys(field)[0];
        const userField = [
            'national_identity_number',
            // 'first_name',
            // 'last_name',
            // 'email',
            // 'phone_number'
        ];

        if (!state.single) {
            if (key === 'competence') {
                state.createPayload.competence.id = field[key] ? field[key].id : null;
                state.createPayload.competence.name = field[key] ? field[key].name : null;
                state.createPayload.competence.has_id06 = field[key] ? field[key].has_id06 : null;
                state.createPayload.competence.has_ssg = field[key] ? field[key].has_ssg : null;
                state.createPayload.competence.sub_competences = field[key] ? field[key].sub_competences : null;
                state.createPayload.competence.inherited_sub_competences = field[key]
                    ? field[key].inherited_sub_competences
                    : null;
                state.createPayload.competence.valid_months = field[key] ? field[key].valid_months : null;
                state.createPayload.competence.annual_year_date = field[key] ? field[key].annual_year_date : null;
                state.createPayload.competence.competence_type = field[key] ? field[key].competence_type : null;
                state.createPayload.competence.issuing_authority = field[key] ? field[key].issuing_authority : null;
                state.createPayload.issuing_authority = field[key] ? field[key].issuing_authority : null;
                state.createPayload.competence.members = field[key] ? field[key].members : null;
                state.createPayload.group_competences = [];

                //sorry for this!!! <3
                state.createPayload.expires_at = state.createPayload.competence.valid_months
                    ? state.createPayload.competence.valid_months
                    : 0;

                state.createPayload.start_date = state.createPayload.meta.start_date;
                state.createPayload.end_date = state.createPayload.meta.end_date;
                state.createPayload.total_hours = state.createPayload.meta.total_hours;
                state.createPayload.total_hours_distance = state.createPayload.meta.total_hours_distance;
                state.createPayload.note = state.createPayload.meta.note;
                //state.createPayload.custom_expire_date = state.createPayload.competence.annual_year_date;
            }

            if (key === 'issuer') {
                state.createPayload.issuer.id = field[key] ? field[key].id : null;
                state.createPayload.issuer.name = field[key] ? field[key].name : null;
            }

            if (state.createPayload.certificates) {
                const certIndex = state.createPayload.certificates.findIndex((c) => c.index === state.editIndex);

                if (userField.includes(key)) {
                    state.createPayload.certificates[certIndex].user[key] = field[key];
                } else {
                    if (key === 'issued_at') {
                        state.createPayload.certificates[certIndex][key] = field[key];
                    }

                    if (key === 'client') {
                        state.createPayload.certificates[certIndex].client = field[key] ? field[key] : {};
                    }
                }
            }

            if (key === 'expires_at') {
                state.createPayload.expires_at = field[key];
            }

            if (key === 'custom_expire_date') {
                state.createPayload.custom_expire_date = field[key];
            }

            if (key === 'issuing_authority') {
                state.createPayload.issuing_authority = field[key];
            }
        } else {
            Object.keys(state.createPayload).map((key) => {
                if (key in field) {
                    state.createPayload[key] = field[key];
                }
            });
        }

        state.nextStepReady = !!(state.createPayload.competence.id && state.createPayload.issuer.id);
    },
    UPDATE_CERTIFICATE(state, obj) {
        const userKeys = [
            // 'first_name',
            // 'last_name',
            // 'phone_number',
            // 'email',
            'national_identity_number',
            'foreign_national_identity_number',
        ];
        const cert = state.createPayload.certificates.find((u) => u.index === obj.index);

        if (cert) {
            let stateInCert = cert;

            if (userKeys.includes(obj.key)) {
                stateInCert = cert.user;
            }

            stateInCert[obj.key] = obj.value;
        }
    },
    VALIDATE_EDIT_PREVIEW(state, obj) {
        const index = state.createPayload.certificates.findIndex((o) => o.index === obj.index);
        const status = state.createPayload.certificates.filter((a) => a.status === false).length > 0;

        if (index > -1) {
            state.createPayload.certificates[index].status = obj.hasFormError;
        }

        state.hasFormError = status;
    },
    SET_EDIT_ID(state, obj) {
        state.editId = obj.id;
        state.editIndex = obj.index;
    },
    REMOVE_CERT(state) {
        const certIndex = state.createPayload.certificates.findIndex((c) => c.index === state.editIndex);
        state.createPayload.certificates.splice(certIndex, 1);

        // Check if we got any errors left
        state.hasFormError = state.createPayload.certificates.filter((a) => a.status === false).length > 0;
    },
    SET_UPLOADED_CERTIFICATES(state, array) {
        if (array.length > 0) {
            array.forEach((item, index) => {
                // Save the current index of each item
                item.index = index;
                // Check and save if the uploaded payload has new clients
                if (
                    item.client &&
                    !state.preloads.clients.some(
                        (c) =>
                            c.organization_number === item.client.organization_number && c.email === item.client.email
                    )
                ) {
                    state.preloads.clients.push(item.client);
                }
            });

            state.createPayload.certificates = array;
            state.preview = true;
        }
    },
    SET_PRELOADS(state, preloads) {
        if (preloads.competences) {
            // Kompetensbevis cannot be issued on main competences
            state.preloads.competences = preloads.competences.filter((competence) => !competence.is_main);
        }

        if (preloads.issuer_users) {
            const userObj = JSON.parse(localStorage.getItem('system_cache'));

            preloads.issuer_users.map((user) => {
                state.preloads.issuer_users.push({
                    id: user.id,
                    name: `${user.first_name} ${user.last_name}`,
                });

                if (user.id === userObj.id) {
                    state.createPayload.issuer = {
                        id: user.id,
                        name: `${user.first_name} ${user.last_name}`,
                    };
                }
            });
        }

        if (preloads.clients) {
            preloads.clients.forEach((item) => {
                if (
                    !state.preloads.clients.some(
                        (c) =>
                            c.organization_number === item.organization_number &&
                            c.email === item.email &&
                            c.name === item.name
                    )
                ) {
                    state.preloads.clients.push(item);
                }
            });
        }
    },
    ABORT_PREVIEW(state) {
        state.createPayload.file = '';
        state.createPayload.certificates = [];
        state.preview = false;
        state.editId = null;
        state.editIndex = null;
        state.hasFormError = false;
    },
    CLEAR_CREATE_PAYLOAD: (state) => {
        state.createPayload.first_name = '';
        state.createPayload.last_name = '';
        state.createPayload.national_identity_number = '';
        state.createPayload.foreign_national_identity_number = false;
        state.createPayload.phone_number = '';
        state.createPayload.email = '';
        state.createPayload.client = {};
        state.createPayload.issued_at = null;
        state.createPayload.meta = {};
    },
    SET_CREATE_PAYLOAD_META_KEYS: (state, meta) => {
        Object.keys(meta).forEach(function (key) {
            state.createPayload.meta[key] = meta[key];
        });
    },
    SET_CREATE_PAYLOAD_META: (state, field) => {
        Object.keys(field).forEach(function (key) {
            state.createPayload.meta[key] = field[key];
        });
    },
    SET_CREATE_PAYLOAD_CUSTOM_EXPIRE_DATE: (state, date) => {
        state.createPayload.custom_expire_date = date;
    },
    SET_GROUP_COMPETENCES: (state, rows) => {
        state.createPayload.group_competences = rows;

        // Avmarkeras den sista ID06-/SSG-kompetensen försvinner reglaget, och ett
        // kvarglömt true skulle annars skicka "Nästa" vidare till köpmodalen.
        if (!rows.some((row) => row.has_id06)) {
            state.createPayload.order_id06 = false;
        }
        if (!rows.some((row) => row.has_ssg)) {
            state.createPayload.order_ssg = false;
        }
    },
};

const actions = {
    CREATE_CERTIFICATE: async ({ commit, getters, dispatch }) => {
        let payload = getters['GET_PAYLOAD'];

        commit('GlobalStore/SET_SAVE_STATUS', 'pending', { root: true });

        return await createCertificate(payload)
            .then((response) => {
                if (response.status !== 'Error') {
                    commit('CertificateStore/SET_NEW_CREATED', response.data, { root: true });
                }

                commit('GlobalStore/SET_SAVE_STATUS', response.status, { root: true });

                let snackbar = setSnackbar(response, true);

                if (response.data && response.data === 'incomplete_billing_details') {
                    snackbar.btnText = 'Betaluppgifter';
                    snackbar.btnHref = () => (location.href = '/department/payment#billing');
                }

                dispatch('GlobalStore/SET_SNACKBAR', snackbar, { root: true });

                // Warning means some certificates were created and some were skipped —
                // the same branch that stored them above. Reporting that as a failure
                // would invite the user to re-submit certificates that already exist.
                return response.status !== 'Error';
            })
            .catch(() => {
                commit('GlobalStore/SET_SAVE_STATUS', 'Error', { root: true });
                return false;
            });
    },
    UPLOADED_FILE: async ({ commit, state, dispatch }) => {
        const cache = getCache();

        if (!cache) {
            return false;
        }

        const formData = new FormData();
        const blob = await fetch(state.createPayload.file).then((res) => res.blob());

        formData.append('file', blob);
        formData.append('department_id', cache.department_id);
        formData.append('competence_id', state.createPayload.competence.id);
        formData.append('issuer_id', state.createPayload.issuer.id);

        if (isGroup(state.createPayload.competence.competence_type)) {
            (state.createPayload.group_competences ?? []).forEach((row) =>
                formData.append('member_ids[]', row.competence_id)
            );
        }
        formData.append('custom_expire_date', state.createPayload.custom_expire_date);
        formData.append('sub_competences', state.createPayload.meta.sub_competences);
        formData.append('start_date', state.createPayload.meta.start_date);
        formData.append('end_date', state.createPayload.meta.end_date);
        formData.append('total_hours', state.createPayload.meta.total_hours);
        formData.append('total_hours_distance', state.createPayload.meta.total_hours_distance);
        formData.append('note', state.createPayload.meta.note);

        return await uploadCertificateFile(formData)
            .then((response) => {
                if (response.status === 'Error') {
                    dispatch('GlobalStore/SET_SNACKBAR', setSnackbar(response), { root: true });
                    return;
                }

                if (response.data.length > 0 && response.status === 'Success') {
                    const messages = JSON.parse(response.message);

                    response.data.forEach((row) => {
                        row.user.national_identity_number = row.user.national_identity_number_raw;
                        row.issued_at = formatDate(row.issued_at);
                        delete row.user.national_identity_number_raw;

                        if (messages[row.rowNr]) {
                            row.messages = { ...messages[row.rowNr], ...row.messages };
                            row.status = false;
                        }

                        if (row.client) {
                            row.client = {
                                ...row.client,
                                valid: SwedishOrgNr.validate(row.client.organization_number) && row.client.name,
                                // Email.validate(row.client.email) &&
                            };
                        }
                    });
                    commit('SET_UPLOADED_CERTIFICATES', response.data);
                }

                return response.status === 'Success';
            })
            .catch((error) => {
                dispatch('GlobalStore/SET_SNACKBAR', setSnackbar(error), { root: true });
                commit('GlobalStore/SET_SAVE_STATUS', 'Error', { root: true });
            });
    },
    LOAD_PRELOADS: async ({ commit }) => await getPreloads().then((response) => commit('SET_PRELOADS', response.data)),
    ABORT_PREVIEW: ({ commit }) => {
        // Clear all message before anything
        commit('GlobalStore/CLEAR_SNACKBAR', null, { root: true });
        commit('ABORT_PREVIEW');
    },
};

// En kompetensgrupp bär varken ID06-kod eller SSG-koppling själv, så flaggorna
// kommer från de valda medlemskompetenserna. Reglagen i sista steget visas alltså
// så fort någon av dem är kopplad; backend avgör sedan per certifikat om
// beställningen verkligen läggs.
const selectedGroupRows = (state) =>
    isGroup(state.createPayload.competence.competence_type) ? state.createPayload.group_competences ?? [] : null;

const getters = {
    GET_HAS_ID06: (state) =>
        selectedGroupRows(state)?.some((row) => row.has_id06) ?? state.createPayload.competence.has_id06,
    GET_HAS_SSG: (state) =>
        selectedGroupRows(state)?.some((row) => row.has_ssg) ?? state.createPayload.competence.has_ssg,
    // Antal kompetenser per person som faktiskt ger en ID06-registrering — priset i
    // köpmodalen är styckpris per certifikat, inte per person.
    GET_ID06_COMPETENCE_COUNT: (state) => selectedGroupRows(state)?.filter((row) => row.has_id06).length ?? 1,
    isSingle: (state) => state.single,
    isPreview: (state) => state.preview,
    getHasUploadedFile: (state) => state.createPayload.file !== '',
    getPreloads: (state) => {
        const copy = { ...state.preloads };

        if (copy.clients.length > 0) {
            copy.clients = copy.clients.map((client) => {
                return {
                    ...client,
                };
            });
        }

        return copy;
    },
    HAS_ERRORS: (state) => state.hasFormError,
    GET_IS_NEXT_STEP_READY: (state) => state.nextStepReady,
    GET_IS_NEXT_STEP: (state) => state.nextStep,
    editObj: (state) => {
        return {
            id: state.editId,
            index: state.editIndex,
        };
    },
    GET_SELECTED_COMPETENCE_NAME: (state) => state.createPayload?.competence?.name || null,
    GET_SELECTED_COMPETENCE: (state) => state.createPayload?.competence || null,
    GET_PAYLOAD_META: (state) => {
        return {
            certificates: state.createPayload.certificates,
            title: `${state.createPayload.competence.name}, utfärdare ${state.createPayload.issuer.name}`,
        };
    },
    GET_PAYLOAD: (state) => {
        let payload = {
            competence_id: state.createPayload.competence.id,
            issuer_id: state.createPayload.issuer.id,
            certificates: state.createPayload.certificates,
            meta: state.createPayload.meta,
            issuing_authority: state.createPayload.issuing_authority || null,
        };

        /* same fields as we can find inside of the excel file */
        if (state.single) {
            payload.certificates = [];

            payload.certificates.push({
                issued_at: state.createPayload.issued_at,
                client: state.createPayload.client,
                order_id06: state.createPayload.order_id06,
                order_ssg: state.createPayload.order_ssg,
                first_name: state.createPayload.first_name,
                last_name: state.createPayload.last_name,
                email: state.createPayload.email,
                phone_number: state.createPayload.phone_number,
                authority_reference: state.createPayload.authority_reference || null,
                verified: state.createPayload.verified || false,
                certified_department_id: state.createPayload.certified_department_id || null,
                user: {
                    national_identity_number: state.createPayload.national_identity_number,
                    foreign_national_identity_number: state.createPayload.foreign_national_identity_number,
                },
            });
        } else {
            payload.file = state.createPayload.file;
        }

        // Kompetensgrupp: certifikaten ställs ut på de valda medlemmarna med egen giltighet per rad
        if (isGroup(state.createPayload.competence.competence_type)) {
            delete payload.competence_id;
            payload.group_competence_id = state.createPayload.competence.id;
            payload.issuing_authority = null;
            payload.competences = groupRowsToApi(state.createPayload.group_competences);

            // storeMany lets a non-null group row override every participant's own value.
            if (!state.single) {
                payload.competences = payload.competences.map((row) => ({ ...row, authority_reference: null }));
            }

            return payload;
        }

        /* to included custom expire dates + annual dates to our payload */

        if (state.createPayload.custom_expire_date) {
            payload.custom_expire_date = moment(state.createPayload.custom_expire_date, 'YYYY-MM-DD').format(
                'YYYY-MM-DD'
            );
        } else if (state.createPayload.expires_at || state.createPayload.expires_at === 0) {
            payload.expires_at = state.createPayload.expires_at;
        }

        return payload;
    },
    GET_EMAILS: (state) => state.createPayload.certificates.map((c) => c.email),
    GET_SSNS: (state) => state.createPayload.certificates.map((c) => c.user.national_identity_number),
    GET_CUSTOM_EXPIRE_DATE: (state) => state.createPayload.custom_expire_date,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
